import * as Segment from 'types/Recipe/Print/Analysis/Segment';

export type Type = Segment.Type[];

export function create(): Type {
	return [];
}
